export const SURVEY_EVENTS = {
    SURVEY_RATING: "SURVEY_RATING",
    SURVEY_COMMENT: "SURVEY_COMMENT",
};

export const SURVEY_RATING = {
    START: "SURVEY_RATING_START",
    SUCCESS: "SURVEY_RATING_SUCCESS",
    ERROR: "SURVEY_RATING_ERROR",
};

export const SURVEY_COMMENT = {
    START: "SURVEY_COMMENT_START",
    SUCCESS: "SURVEY_COMMENT_SUCCESS",
    ERROR: "SURVEY_COMMENT_ERROR",
};

const defaultSurveyRatingState = {
    putSurveyRatingError: false,
    putSurveyRatingData: false,
    putSurveyRatingLoading: false,
};

const defaultSurveyCommentState = {
    putSurveyCommentError: false,
    putSurveyCommentData: false,
    putSurveyCommentLoading: false,
};

const defaultState = {
    ...defaultSurveyRatingState,
    ...defaultSurveyCommentState,
};

const surveyReducer = (state = defaultState, action = {}) => {
    switch (action.event) {
        case SURVEY_EVENTS.SURVEY_RATING:
            return {
                ...state,
                putSurveyRatingLoading: action.type === SURVEY_RATING.START,
                putSurveyRatingData: action.type === SURVEY_RATING.SUCCESS ? action.payload : false,
                putSurveyRatingError: action.type === SURVEY_RATING.ERROR ? action.payload : false,
            };
        case SURVEY_EVENTS.SURVEY_COMMENT:
            return {
                ...state,
                putSurveyCommentLoading: action.type === SURVEY_COMMENT.START,
                putSurveyCommentData: action.type === SURVEY_COMMENT.SUCCESS ? action.payload : false,
                putSurveyCommentError: action.type === SURVEY_COMMENT.ERROR ? action.payload : false,
            };
        default:
            return state;
    }
};

export default surveyReducer;
